'use strict';

module.exports = require('./scripts');



//////////////////
// WEBPACK FOOTER
// ./~/paste-image/index.js
// module id = 1666
// module chunks = 1